export default __webpack_public_path__ + "static/media/GR00042-webinar_illustration.ecad84e4.svg";